// @core/api/endpoints/billing/list_invoices.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListInvoicesResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List invoices
 * Returns a paginated list of invoices with optional filtering by billing account, status, and date range.
 */
export async function ListInvoices(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListInvoicesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/invoices`;
  const requestOptions = options;
  return client.get<ListInvoicesResponse>(requestPath, { ...requestOptions, params });
}
